<template>
    <header>
        <div class="layer2"></div>
        <div class="layer3"></div>
        <div class="top">
            <div class="d-flex justify-content-between">
                <router-link to="/">
                    <div class="d-flex brand-box">
                        <div class="logo"></div>
                        <div class="logo2"></div>
                    </div>
                </router-link>
                <TopNavigation/>
            </div>
        </div>
        <div class="title" :style="'width:'+titleWidth">
            <div>
                <h1>{{title}}</h1>
            </div>
        </div>
    </header>
</template>

<script>
import TopNavigation from '../common/TopNavigation'
export default {
  name: 'Header',
  components: {TopNavigation},
  props: {
    title: {
      type: String
    },
    titleWidth: {
      type: String
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/front/components/pages/layout/static/Header.vue